module.exports = __webpack_public_path__ + "static/1-918c4e611b7ba5f1727c8d63d143313e.png";